module.exports = __webpack_public_path__ + "img/stethoscope.ef9a6a61.svg";